<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <p v-if="!showForm" class="font-weight-bold">
            Muchas gracias por llenar la información solicitada
        </p>

        <v-form ref="form" v-if="showForm" v-model="valid" lazy-validation>
            <p class="font-weight-bold">
                Progreso ficha:
                <v-progress-linear
                        :value="progress"
                        height="10"
                        striped
                        color="deep-orange"
                ></v-progress-linear>
            </p>
            <v-stepper v-model="e1">
                <v-stepper-header>
                    <v-stepper-step :editable='false' step="1">1. Información personal y laboral
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :editable='false' step="2">2. Exposición al virus
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :editable='false' step="3">3. Medidas de protección
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="4" :editable='false'>4. Condiciones de salud</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-form ref="form1" v-model="validForm1" lazy-validation>
                                    <p class="font-weight-bold">1. Información personal y laboral</p>
                                    <v-data-table
                                            :items="covid.lista[0].datos"
                                            class="elevation-1"
                                            hide-actions
                                            hide-headers
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">
                                                <p v-if="props.item.tipo==0" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <p v-if="props.item.tipo==1" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==1"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        :style="props.item.color"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <p v-if="props.item.tipo==2" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==2"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        @change="props.item.valor2=''"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2==null && props.item.label3==null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino') "
                                                        :label="props.item.label2"
                                                        v-model="props.item.valor2"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <v-select
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2!=null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino')"
                                                        :label="props.item.label2"
                                                        :items="props.item.data2"
                                                        v-model="props.item.valor2"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && props.item.label3!=null && (props.item.valor2=='Otros medios'||props.item.valor2=='Otros' || props.item.valor2=='SI'||props.item.valor2=='Femenino') "
                                                        :label="props.item.label3"
                                                        v-model="props.item.valor3"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==3" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-text-field
                                                        v-if="props.item.tipo==3 && props.item.label!='g. Número teléfono celular (personal)'"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-text-field>
                                                <v-text-field
                                                        v-if="props.item.tipo==3 && props.item.label=='g. Número teléfono celular (personal)'"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                        @blur="validatePhone(props.item)"
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==4" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-textarea
                                                        v-if="props.item.tipo==4"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-textarea>
                                                <v-checkbox
                                                        v-if="props.item.tipo==5"
                                                        v-model="props.item.valor"
                                                        :label="props.item.label"
                                                ></v-checkbox>
                                                <p v-if="props.item.tipo==7" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select v-if="props.item.tipo==7"
                                                          v-model="props.item.valor"
                                                          :items="$store.state.companies"
                                                          item-value="id"
                                                          item-text="name"
                                                          :rules="[v => !!v || 'Empresa es requerido']"
                                                          return-object
                                                          persistent-hint
                                                          required
                                                ></v-select>
                                                <v-select
                                                        v-if="props.item.tipo==12"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==12 && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI') "
                                                        :label="props.item.label2"
                                                        v-model="props.item.valor2"
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==13" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-text-field
                                                        v-if="props.item.tipo==13"
                                                        v-model="props.item.valor"
                                                        @keypress="permitOnlyNumbers($event)"
                                                ></v-text-field>
                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            No se han encontrado resultados para "{{ search }}".
                                        </v-alert>
                                    </v-data-table>
                                </v-form>
                            </v-flex>
                        </v-layout>
                        <v-btn
                                color="primary"
                                :disabled="!validForm1"
                                @click="processContinue"
                                @blur="topFunction"
                        >
                            Continuar
                        </v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-form ref="form2" v-model="validForm2" lazy-validation>
                                    <p class="font-weight-bold">2. Exposición al virus</p>
                                    <v-data-table
                                            :items="covid.lista[1].datos"
                                            class="elevation-1"
                                            hide-actions
                                            hide-headers
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">
                                                <p v-if="props.item.tipo==0" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <p v-if="props.item.tipo==1" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==1"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        :style="props.item.color"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <p v-if="props.item.tipo==2" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==2"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        @change="props.item.valor2=''"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2==null && props.item.label3==null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre') "
                                                        :label="props.item.label2"
                                                        v-model="props.item.valor2"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <v-select
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2!=null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre')"
                                                        :label="props.item.label2"
                                                        :items="props.item.data2"
                                                        v-model="props.item.valor2"
                                                        @change="props.item.valor3=''"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && (props.item.valor2=='Otros medios'||props.item.valor2=='Otros' ||props.item.valor2=='Otro'|| props.item.valor2=='SI'||props.item.valor2=='Femenino') "
                                                        :label="props.item.label3"
                                                        v-model="props.item.valor3"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==3" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-text-field
                                                        v-if="props.item.tipo==3"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==4" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-textarea
                                                        v-if="props.item.tipo==4"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-textarea>
                                                <p v-if="props.item.tipo==12" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==12"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==12 && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI') "
                                                        :label="props.item.label2"
                                                        v-model="props.item.valor2"
                                                ></v-text-field>

                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            No se han encontrado resultados para "{{ search }}".
                                        </v-alert>
                                    </v-data-table>
                                </v-form>
                            </v-flex>
                        </v-layout>
                        <v-btn text @click="e1 = 1" @blur="topFunction">Regresar</v-btn>
                        <v-btn
                                color="primary"
                                :disabled="!validForm2"
                                @click="processContinue"
                                @blur="topFunction"
                        >
                            Continuar
                        </v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-form ref="form3" v-model="validForm3" lazy-validation>
                                    <p class="font-weight-bold">3. Medidas de protección</p>
                                    <v-data-table
                                            :items="covid.lista[2].datos"
                                            class="elevation-1"
                                            hide-actions
                                            hide-headers
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">
                                                <p v-if="props.item.tipo==0" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <p v-if="props.item.tipo==1" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==1"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        :style="props.item.color"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <img v-if="props.item.image!=null" :src="props.item.image" width="100px"
                                                     height="100px">
                                                <p v-if="props.item.tipo==2" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==2"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2==null && props.item.label3==null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre') "
                                                        :label="props.item.label2"
                                                        v-model="props.item.valor2"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2!=null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre')"
                                                   class="font-weight-bold">
                                                    {{props.item.label2}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2!=null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre')"
                                                        :items="props.item.data2"
                                                        v-model="props.item.valor2"
                                                        @change="props.item.valor3=''"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <p v-if="props.item.tipo==3" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-text-field
                                                        v-if="props.item.tipo==3"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==4" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-textarea
                                                        v-if="props.item.tipo==4"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-textarea>
                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            No se han encontrado resultados para "{{ search }}".
                                        </v-alert>
                                    </v-data-table>
                                </v-form>
                            </v-flex>
                        </v-layout>
                        <v-btn text @click="e1 = 2" @blur="topFunction">Regresar</v-btn>
                        <v-btn
                                color="primary"
                                :disabled="!validForm3"
                                @click="processContinue"
                                @blur="topFunction"

                        >
                            Continuar
                        </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                        <v-layout>
                            <v-flex xs12 sm10 offset-sm1>
                                <v-form ref="form4" v-model="validForm4" lazy-validation>
                                    <p class="font-weight-bold">4. Condiciones de salud</p>
                                    <v-data-table
                                            :items="covid.lista[3].datos"
                                            class="elevation-1"
                                            hide-actions
                                            hide-headers
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">
                                                <p v-if="props.item.tipo==0" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <p v-if="props.item.tipo==1" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==1"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        :style="props.item.color"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <p v-if="props.item.tipo==2" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-select
                                                        v-if="props.item.tipo==2"
                                                        :items="props.item.data"
                                                        v-model="props.item.valor"
                                                        @change="props.item.valor2=''"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2==null && props.item.label3==null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino') "
                                                        :label="props.item.label2"
                                                        v-model="props.item.valor2"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <v-select
                                                        v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2!=null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino')"
                                                        :label="props.item.label2"
                                                        :items="props.item.data2"
                                                        v-model="props.item.valor2"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-select>
                                                <v-text-field
                                                        v-if="props.item.tipo==2 && props.item.label3!=null && (props.item.valor2=='Otros medios'||props.item.valor2=='Otros' || props.item.valor2=='SI'||props.item.valor2=='Femenino') "
                                                        :label="props.item.label3"
                                                        v-model="props.item.valor3"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        :required="props.item.validate==null?true:false"
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==3" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-text-field
                                                        v-if="props.item.tipo==3"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-text-field>
                                                <p v-if="props.item.tipo==4" class="font-weight-bold">
                                                    {{props.item.label}}</p>
                                                <v-textarea
                                                        v-if="props.item.tipo==4"
                                                        v-model="props.item.descripcion"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                        required
                                                ></v-textarea>
                                            </td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            No se han encontrado resultados para "{{ search }}".
                                        </v-alert>
                                    </v-data-table>
                                </v-form>
                            </v-flex>
                        </v-layout>
                        <v-btn text
                               @click="e1 = 3"
                               @blur="topFunction"
                        >Regresar
                        </v-btn>
                        <v-btn color="primary" :disabled="!validForm4"
                               @click="processContinue" dark>Enviar
                        </v-btn>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </v-form>
        <div class="text-xs-center" v-if="covid!=null &&  showForm">

        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogErrorExist"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Ya tiene un registro de ficha vigente.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogErrorExist = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogCondition"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span class="font-weight-bold">Términos y condiciones.</span>
                    <br>
                    <div style="text-align : justify;">
                        Garantizamos la confidencialidad de la información médico-paciente. Al momento de aceptar
                        estos términos y condiciones, usted nos autoriza a verificar su localización geográfica, a fin
                        de
                        ser más precisos en el monitoreo epidemiológico y oportunos en el apoyo que se le puede
                        brindar. Usted podrá en cualquier momento y sin explicación alguna, anular esta opción de
                        geo referencia y también salir del programa de monitoreo del que está siendo beneficiado por
                        parte de su empleador, con su sola notificación.
                    </div>
                </v-card-title>
                <v-card-actions>

                    <v-btn
                            color="primary"
                            text
                            @click="dialogCondition = false; checkbox=true"
                    >
                        Aceptar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogCondition = false; checkbox=false"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInfoFill"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique que la información ingresada sea correcta.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogInfoFill = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogInfo"
                fullscreen=""
        >
            <v-card
                    class="mx-auto"
                    max-width="400"
            >
                <v-img
                        class="white--text align-end"
                        height="200px"
                        src="https://inscora-images.s3.amazonaws.com/covid-inscora.jpeg"
                >
                </v-img>
                <v-layout>
                    <v-flex xs12 sm10 offset-sm1>
                        <v-card-text class="text--primary">
                            <div style="text-align : justify;">La actual situación de pandemia CoViD-19 obliga a romper
                                la práctica de la consulta
                                presencial para
                                realizar la evaluación, diagnóstico, prevención y tratamiento de esta enfermedad.
                                El recurso tecnológico debe servir para ayudar a los trabajadores y a sus familiares
                                para evitar ser contagiados.
                            </div>
                            <br>
                            <div style="text-align : justify;">INSCORA ha desarrollado esta herramienta como parte de un
                                programa de monitoreo
                                epidemiológico para COVID-19, que tendrá fases sucesivas de diagnóstico de la enfermedad
                                medidas
                                de prevención y protección y atención de los problemas de salud si aparecieran. Además
                                de control
                                de su cumplimiento hasta conseguir el alta definitiva del trabajador/ paciente y de ser
                                requerido de
                                su entorno familiar.
                            </div>
                            <br>
                            <div style="text-align : justify;">
                                No existen respuestas malas ni buenas. Favor leer toda la encuesta antes de y luego
                                volver al inicio
                                para responder con absoluta veracidad y de forma completa, la información permitirá
                                iniciar un
                                proceso de acompañamiento médico y de las condiciones de seguridad en sus puestos de
                                trabajo, lo
                                que redundará no solo en su beneficio personal sino en la productividad y sostenibilidad
                                de su
                                compañía.
                            </div>

                            <br>

                            <v-checkbox
                                    @click="dialogCondition=true; checkbox=true"
                                    v-model="checkbox"
                                    label="Aceptar términos y condiciones"
                            ></v-checkbox>
                            <br>
                            <br>

                            <p class="font-weight-bold">Por favor complete la siguiente información para comenzar con la
                                ficha.</p>
                            <v-form ref="form" v-model="validDialog" lazy-validation>
                                <v-layout>
                                    <v-flex xs12 sm10 offset-sm1>
                                        <v-text-field
                                                name="email"
                                                label="Email"
                                                id="email"
                                                :rules="emailRules" v-model="covidEntity.email"
                                                required
                                        ></v-text-field>
                                        <v-text-field
                                                name="cedula"
                                                label="Cédula/Pasaporte"
                                                id="cedula"
                                                :rules="[v => !!v || 'La identificación es requerida', v => (v && v.length <= 15) || 'El valor debe tener menos de 15 caracteres']"
                                                required
                                                v-model="covidEntity.identification"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    text
                                    :disabled="!validDialog || !checkbox"
                                    @click="dialogAceptAlarmForm=true"
                            >
                                Continuar con ficha
                            </v-btn>
                        </v-card-actions>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogAceptAlarmForm"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Está seguro de que desea continuar con la información ingresada?</span>
                    <span>Identificación: {{this.covidEntity.identification}} Email: {{this.covidEntity.email}}</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogAceptAlarmForm = false"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="iniciarEncuesta()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogConfirmSaveAlert"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Está seguro de que desea enviar toda la información ingresada?</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogConfirmSaveAlert = false"
                    >
                        Regresar
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="saveData()"
                    >
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>


    import pdf from 'vue-pdf'
    import Covid from "../../model/Covid";
    import CovidEntity from "../../model/CovidEntity";
    import CovidPatient from "../../model/CovidPatient";

    const sha = require('js-sha256');
    export default {
        components: {
            pdf
        },
        props: ['number'],
        data() {
            return {
                e1: 1,
                checkbox: false,
                editable: true,
                covid: new Covid(),
                search: '',
                valid: false,
                validForm1: false,
                validForm2: false,
                validForm3: false,
                validForm4: false,
                validDialog: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                dialogSuccess: false,
                dialogError: false,
                dialogErrorExist: false,
                dialogCondition: false,
                dialogSucess: false,
                dialogInfo: true,
                dialogInfoFill: false,
                covidEntity: new CovidEntity(),
                dialogConfirmSaveAlert: false,
                dialogAceptAlarmForm: false,
                showForm: true,
                submitCont: 0,
                emailRules: [
                    v => !!v || 'El email es requerido',
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
                ],

            };
        },
        computed: {
            progress() {
                if (this.e1 == 1) {
                    return 0
                } else if (this.e1 == 2) {
                    return 25
                } else if (this.e1 == 3) {
                    return 50
                } else if (this.e1 == 4) {
                    return 75
                }
            }
        },
        methods: {

            iniciarEncuesta() {
                if (this.$refs.form.validate()) {
                    this.dialogAceptAlarmForm = false
                    this.covidEntity.identification = this.covidEntity.identification.trim()
                    this.covidEntity.email = this.covidEntity.email.trim()
                    this.$store.dispatch('existCovid', this.covidEntity.identification).then(
                        response => {
                            if (!response.data) {
                                //Si no existe crea uno nuevo
                                this.dialogInfo = false
                                this.topFunction()
                            } else {
                                // Si existe, verifica que se ecuentre Inactivo las alarmas para generar uno nuevo.
                                this.$store.dispatch('getCovidPatientByIdentification', this.covidEntity.identification).then(
                                    response => {
                                        if (response.data != "") {
                                            let covidPatient = response.data
                                            this.covid.lista[0].datos[1].descripcion = covidPatient.lastName
                                            this.covid.lista[0].datos[2].descripcion = covidPatient.name
                                            this.covid.lista[0].datos[5].descripcion = covidPatient.company.name
                                            //Verifica que sea inactivo
                                            if (covidPatient.status == 'INACTIVO') {
                                                this.dialogInfo = false
                                                this.topFunction()
                                            } else {
                                                //Si está activo no puede realizar la ficha
                                                this.dialogErrorExist = true
                                            }
                                        } else {
                                            this.dialogErrorExist = true
                                        }
                                    }
                                );
                            }
                        },
                        error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                        }
                    );

                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(this.showPosition);
                    } else {
                        x.innerHTML = "Geolocation is not supported by this browser.";
                    }
                }

            },
            cleanData() {
                this.$refs.form.reset();
                this.covid = new Covid();
                this.valid = false;
                this.dialog = false;
                this.covidEntity = new CovidEntity()
            },
            saveData() {
                if (this.$refs.form.validate() && this.submitCont == 0) {
                    this.submitCont++
                    this.$store.state.progress = true;
                    this.dialogConfirmSaveAlert = false
                    this.covidEntity.value = JSON.stringify(this.covid)
                    this.covidEntity.date = new Date()
                    this.covidEntity.name = this.covid.lista[0].datos[1].descripcion + " " + this.covid.lista[0].datos[2].descripcion
                    this.covidEntity.company = this.covid.lista[0].datos[5].valor.name
                    this.covidEntity.phone = this.covid.lista[0].datos[11].descripcion
                    this.covidEntity.uniqueCode = this.getUniqueCode(this.covidEntity.identification)
                    this.covidEntity.companyEntity = this.covid.lista[0].datos[5].valor
                    this.$store.dispatch('addCovid', this.covidEntity).then(
                        response => {
                            this.dialogSuccess = true
                            this.showForm = false

                            let covidPatient = new CovidPatient()
                            covidPatient.identification = this.covidEntity.identification
                            covidPatient.name = this.covid.lista[0].datos[2].descripcion
                            covidPatient.lastName = this.covid.lista[0].datos[1].descripcion
                            covidPatient.status = 'ACTIVO'
                            covidPatient.company = this.covid.lista[0].datos[5].valor
                            covidPatient.agency = null
                            covidPatient.phone = this.covid.lista[0].datos[11].descripcion
                            covidPatient.uniqueCode = this.getUniqueCode(this.covidEntity.identification)
                            covidPatient.userDoctor = null
                            covidPatient.userAsistant = null
                            //Guarda paciente
                            this.$store.dispatch('addCovidPatienFromAlarm', covidPatient).then(response => {
                                this.cleanData();
                            })
                            this.$store.state.progress = false;
                        },
                        error => {
                            this.$store.state.progress = false;
                            this.$store.state.dialogError = true;
                        }
                    );
                    this.dialog = false;
                }
            },
            topFunction() {
                //document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            },
            processContinue() {
                if (this.e1 == 1) {
                    if (this.$refs.form1.validate()) {
                        this.e1 = 2
                    }
                } else if (this.e1 == 2) {
                    if (this.$refs.form2.validate()) {
                        this.e1 = 3
                    }
                } else if (this.e1 == 3) {
                    if (this.$refs.form3.validate()) {
                        this.e1 = 4
                    }
                } else if (this.e1 == 4) {
                    if (this.$refs.form4.validate()) {
                        this.dialogConfirmSaveAlert = true
                    }
                }
            },
            showPosition(position) {
                this.covid.latitude = position.coords.latitude
                this.covid.longitude = position.coords.longitude
            },
            validatePhone(item) {
                if (item.label === 'g. Número teléfono celular (personal)') {
                    confirm('¿El número de telefóno celular ' + item.descripcion + ' ingresado es correcto?')
                }
            },
            getUniqueCode(data) {
                let hashString = sha(data)
                let responseUniqueCode = hashString.substr(0, 10) + hashString.substr(59)
                return responseUniqueCode.toUpperCase()
            },
            permitOnlyNumbers: function ($event) {
                var tecla = $event.charCode;
                if (tecla === 8) {
                    return true
                } else {
                    // Patron de entrada, en este caso solo acepta numeros
                    const patron = /[0-9]/;
                    var tecla_final = String.fromCharCode(tecla);
                    if (!patron.test(tecla_final)) {
                        $event.preventDefault();
                    }
                }
            }
        },
        created() {
            this.covid = new Covid();
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })

        },
    }
</script>

<style scoped>
    li {
        list-style: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/covid/CovidRegister.vue